let stack, configStack

try {
  stack = require("../../stack.json")
  configStack = require("../../config.json")
} catch(error) {
  console.warn("Stack not created yet. Create it by running `sls deploy`")
  stack = {}
}

const config = {
  stripeApiKey: stack.StripeApiKey,
  googleClientId: stack.GoogleClientId,
  pulumiWSSUrl: configStack.pulumi_wss_url,
}


export default config
